import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { Mask, SummaryCardNew } from '@hapvida/hapvida-core-components';

import { CompanyListRouter } from '@flows/private/companies/pages/CompanyList/router';
import { useAuth } from '@hooks';
import { PartnerCompanyStatusChip } from '@flows/private/partnerCompanies/pages/PartnerCompanyList/components/PartnerCompaniesStatusChip';

import { Label, StackRow, LinkRedirect } from './styles';

export const PartnerCompanySummaryMobile = () => {
  const { currentCompany } = useAuth();
  const {
    document = '',
    tradeName,
    legal,
    status,
    paymentDay,
    cutoffDate,
  } = currentCompany ?? {};
  const navigateTo = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleCompanyListRedirect = () => {
    navigateTo(CompanyListRouter?.path);
  };

  const companyData = [
    { label: 'Nome fantasia', value: tradeName },
    { label: 'Razão social', value: legal },
    { label: 'CNPJ', value: Mask.cnpj(document) },
    { label: 'Data corte', value: cutoffDate ?? '-' },
    { label: 'Data de vencimento', value: paymentDay ?? '-' },
  ];

  return (
    <SummaryCardNew.Container>
      <StackRow mb={1}>
        <Typography variant="body1" fontWeight={900}>
          Resumo do contrato
        </Typography>
        {status && (
          <PartnerCompanyStatusChip
            fontSize="12px"
            status={status}
            size="small"
          />
        )}
      </StackRow>

      {companyData.map(item => (
        <StackRow key={item.label}>
          <Label variant="text">{item.label}</Label>
          <Typography variant="text" textAlign={isMobile ? 'right' : 'left'}>
            {item.value}
          </Typography>
        </StackRow>
      ))}

      <StackRow>
        <Label variant="text">Unidades neste contrato</Label>
        <LinkRedirect variant="text" onClick={handleCompanyListRedirect}>
          Mostrar detalhes
        </LinkRedirect>
      </StackRow>
    </SummaryCardNew.Container>
  );
};
